<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: `${sessionStorage.colorCode} !important` }"
      :title="$t('DishDetail.title')"
      left-arrow
      fixed
      @click-left="$router.push('/Dishes')"
    >
    </van-nav-bar>
    <div v-if="detail">
      <div class="dish_content">
        <van-image
          v-if="detail.image"
          width="130px"
          height="130px"
          :src="detail.image.path"
        />
        <div class="info">
          <div
            class="noExceed"
            style="height: 30px; font-size: 17px; line-height: 30px; font-weight: 600;"
          >
            {{ detail.name }}
          </div>
          <div
            class="noExceed"
            style="font-size: 17px; line-height: 17px; font-weight: 600;"
          >
            {{ detail.name_en }}
          </div>
          <div class="dish_footer">
            <van-rate
              v-model="detail.level"
              readonly
              :size="16"
              gutter="3px"
              icon="./static/img/Recommend-s.png"
              void-icon="./static/img/Recommend.png"
            />
            <div class="fontLine">
              <span class="currentPrice"
                >{{ sessionStorage.getItem("currency") }}
                {{
                  detail.type == "o"
                    ? detail.original_price
                    : detail.special_price
                }}</span
              >&nbsp;&nbsp;&nbsp;<span
                class="oldPrice"
                v-show="detail.type == 's'"
                >{{ sessionStorage.getItem("currency") }}
                {{ detail.original_price }}</span
              >
            </div>
          </div>
          <p>{{ detail.introduction }}</p>
        </div>
      </div>
      <div style="height: 3px; width: 100%; background-color: #b7b7b7"></div>
      <div
        v-if="detail.perfer && detail.perfer.data.length > 0"
        class="tasteGropu"
      >
        <div
          class="tasteItem"
          v-for="(item, index) in detail.perfer.data"
          :key="item.id"
        >
          <div class="tasteItemTitle">
            {{ item.name }}<span class="required">*</span>
          </div>
          <span
            class="is_choiced1 tag"
            v-if="detail.perfer.data[index].is_choiced == 1"
          >
            <div
              v-for="(val, key) in item.category.data"
              :key="key"
              class="tasteItemRadio"
              :style="
                perferResult[index][key] == val.id
                  ? {
                      border: `1px solid ${sessionStorage.colorCode}`,
                      background: `${sessionStorage.colorCode}`
                    }
                  : { border: `1px solid ${sessionStorage.colorCode}` }
              "
              :class="[
                perferResult[index][key] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, key, val.id)"
            >
              {{ val.name }}
              <span v-if="val.price != 0"
                >{{ sessionStorage.getItem("currency") }} {{ val.price }}</span
              >
            </div>
          </span>
          <span v-else class="tag">
            <div
              v-for="(val, key) in item.category.data"
              :key="key"
              class="tasteItemRadio"
              :style="
                perferResult[index][0] == val.id
                  ? {
                      border: `1px solid ${sessionStorage.colorCode}`,
                      background: `${sessionStorage.colorCode}`
                    }
                  : { border: `1px solid ${sessionStorage.colorCode}` }
              "
              :class="[
                perferResult[index][0] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, key, val.id)"
            >
              {{ val.name }}
              <span v-if="val.price != 0"
                >{{ sessionStorage.getItem("currency") }} {{ val.price }}</span
              >
            </div>
          </span>
        </div>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            class="tasteItemTextarea"
            :style="{ border: `1px solid ${sessionStorage.colorCode}` }"
            v-model="remark[0]"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
          />
        </div>
      </div>
    </div>
    <van-popup
      v-model="isTasteShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group>
        <van-cell>
          <div style="font-size: 16px;" slot="title">
            {{ $t("DishDetail.tasteNotes") }}
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/dele_staff.png"
            size="26px"
            @click="isTasteShow = false"
          />
        </van-cell>
      </van-cell-group>
      <div
        v-if="detail.perfer && detail.perfer.data.length > 0"
        class="tasteGropu"
      >
        <template v-for="(item, index) in detail.perfer.data">
          <div
            class="tasteItem"
            v-if="item.category.data.length > 0"
            :key="index"
          >
            <div class="tasteItemTitle">{{ item.name }}</div>
            <div
              v-for="(val, key) in item.category.data"
              :key="key"
              class="tasteItemRadio"
              :class="[
                perferResult[index] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, val.id)"
            >
              {{ val.name }}
            </div>
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      perferResult: [],
      remark: [""],
      currency: ""
    };
  },
  mounted: function() {
    this.getDishDetail();
    this.getCurrency();
  },
  methods: {
    // 获取菜品详情
    getDishDetail() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/menu/" + this.$route.params.id + "/takeIndex"
      })
        .then(res => {
          // console.log("菜品详情", res);
          if (res.data.status == 200) {
            this.detail = res.data.data;
            for (var i = 0; i < this.detail.perfer.data.length; i++) {
              if (this.detail.perfer.data[i].category.data.length > 0) {
                this.perferResult[i] = [];
                this.perferResult[i].push(
                  this.detail.perfer.data[i].category.data[0].id
                );
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    showTaste() {
      this.isTasteShow = true;
    },
    changeResult(index, key, id) {
      if (this.detail.perfer.data[index].is_choiced == 1) {
        let arr = this.perferResult[index];
        let type = arr.indexOf(id);
        type == -1 ? (arr[key] = id) : arr.splice(type, 1, "");
        this.$set(this.perferResult, index, arr);
      } else {
        let arr = this.perferResult[index];
        arr[0] = id;
        this.$set(this.perferResult, index, arr);
      }
      // console.log(this.perferResult);
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("DishDetail.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .dish_content .van-image {
  padding: 5px 10px 10px;
}
/deep/ .van-image img {
  border-radius: 10px;
  max-width: 25rem;
  margin: 0 auto;
}
/deep/ .tasteItem .van-cell {
  text-indent: 10px;
  border-radius: 5px;
}
.required {
  color: #ee0a24;
  font-size: 20px;
  font-weight: 600;
  position: relative;
  top: 5px;
  left: 5px;
}
.dish_content {
  display: flex;
}
.dish_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 20px;
  font-weight: 600;
  color: #fe2a00;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  width: calc(90% - 110px);
  height: auto;
  position: relative;
}
.info p {
  font-size: 14px;
  color: #666;
  padding: 0;
  margin-bottom: 10px;
  margin-top: 0px;
  word-break: break-all;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 10px;
  right: 0px;
}
.setPerfer span {
  position: absolute;
  font-size: 12px;
  top: 16px;
  left: 0px;
  width: 50px;
  text-align: center;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  font-size: 18px;
  float: left;
}
.cart_right {
  width: 40%;
  height: 34px;
  line-height: 34px;
  float: right;
  text-align: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
}
.total_price {
  width: 120px;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: auto;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #222;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tag {
  display: flex;
}
.tasteItemRadio {
  width: 100%;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #2f75f4;
  /* text-indent: 10px; */
  text-align: center;
  margin-bottom: 20px;
  margin-right: 10px;
}
.tasteItemRadio span {
  margin-left: 0.625rem;
  color: #ff6666;
}
.tasteItemRadio_act {
  background-color: #000;
  color: #fff;
}
.van-button__text {
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/Shop/DishDetail.vue